export const MAX_LABEL_COUNT = 20;
export const MAX_DESCRIPTION_COUNT = 20;
export const NODE_STROKE = '#CED4D9';
export const EDGE_COLOR = '#DCE2E7';
export const EDGE_SELECTED_COLOR = '#2C8FF2';
export const FONT_FAMILY =
  '"PingFang SC", Helvetica, Arial, "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", SimSun, "sans-serif"';
export const SYNC_STUDIO_VIEW_SELECTION = 'SYNC_STUDIO_VIEW_SELECTION';
